import API from '../utilities/API'
import ComparisonDataTransformer from '../transformers/ComparisonDataTransformer'

const logApi = !!(process.env.NODE_ENV !== 'production')

class Payments {
  constructor () {
    this.serviceCode = ''
  }
  fetchAll ({ from, page, filters }) {
    return API
      .refresh()
      .post({ url: 'fetchPayments',
        data: {
          'dateFrom': from,
          'serviceCode': this.serviceCode,
          'page': page,
          filters
        }
      })
  }
  
  fetchComparisonData ({ filters }) {
    logApi && console.log('Fetching comparison data of the service => ' + this.serviceCode)
    return new Promise((resolve, reject) => {
      API
        .refresh()
        .post({ url: 'fetchPaymentTotals',
          data: {
            'serviceCode': this.serviceCode,
            'date': {
              'type': 'dateBetween',
              'min': filters.from,
              'max': filters.to
            }
          }
        })
        .then(response => {
          console.log('Fetch visits comparison data => ', response)
          resolve(ComparisonDataTransformer.transform(response.DATA, 'Trx.'))
        })
        .catch(reason => {
          console.log('Fetching visits comparison data failed => ', reason)
          reject(reason)
        })
    })
  }
  simulatePayment ({ payment }) {
    return API
      .refresh()
      .post({ url: 'simulatePayment', data: payment })
  }
  whereService ({ serviceCode }) {
    this.serviceCode = serviceCode
    return this
  }
}

export default (new Payments())



// WEBPACK FOOTER //
// ./src/api/services/payments.js